
import React from 'react';
import { Zap, ChefHat } from 'lucide-react';

interface RecipeIconProps {
  type: 'quick-recipe' | 'composition';
  size?: number;
  className?: string;
}

const RecipeIcon: React.FC<RecipeIconProps> = ({ 
  type, 
  size = 12, 
  className = '' 
}) => {
  if (type === 'quick-recipe') {
    return (
      <Zap 
        size={size} 
        className={`text-emerald-700 flex-shrink-0 ${className}`} 
      />
    );
  }
  
  if (type === 'composition') {
    return (
      <ChefHat 
        size={size} 
        className={`text-purple-600 flex-shrink-0 ${className}`} 
      />
    );
  }
  
  return null;
};

export default RecipeIcon;
